export const BASE_WEBSOCKET = process.env.REACT_APP_BASE_URL;

const WEBSOCKETS = {
  chatGroupWS: (chatGroupName, accessToken) => `${BASE_WEBSOCKET}/ws/chat-group/${chatGroupName}/?jwt_token=${accessToken}`,
  inboxWS: (accessToken) => `${BASE_WEBSOCKET}/ws/chat-inbox/?jwt_token=${accessToken}`,
};

export default WEBSOCKETS;
